import apiConfig from 'src/integration/config/apiConfig';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import { useStore } from 'src/integration/store/store';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import { MIN_15 } from 'src/integration/config/constants';
import colors from 'src/integration/styles/colors';

interface FfrEnergyPriceDto {
  id: number;
  date: string;
  time: string;
  mfrrUpEnergyPrice: {
    value: number;
    unit: string;
  };
  mfrrDownEnergyPrice: {
    value: number;
    unit: string;
  };
  afrrUpEnergyPrice: {
    value: number;
    unit: string;
  };
  afrrDownEnergyPrice: {
    value: number;
    unit: string;
  };
}

const emptyChartData = {
  labels: [],
  datasets: [
    {
      label: 'mFRR up energy price',
      data: [],
      backgroundColor: colors.chart.carminePink,
      borderRadius: 4,
      stack: 'mFRR',
    },
    {
      label: 'mFRR down energy price',
      data: [],
      backgroundColor: colors.chart.carminePinkLight,
      borderRadius: 4,
      stack: 'mFRR',
    },
    {
      label: 'aFRR up energy price',
      data: [],
      backgroundColor: colors.chart.pastelOrange,
      borderRadius: 4,
      stack: 'aFRR',
    },
    {
      label: 'aFRR down energy price',
      data: [],
      backgroundColor: colors.chart.pastelOrangeLight,
      borderRadius: 4,
      stack: 'aFRR',
    },
  ],
};

const useFetchFfrEnergyPrice = () => {
  const { settingsStore } = useStore();
  const { selectedSiteId, selectedDate } = settingsStore;

  const response = useReactQueryJava<FfrEnergyPriceDto[], SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.ffrEnergyPrice,
    queryKey: useQueryKey('ffrEnergyPrice', [selectedDate, selectedSiteId?.toString()]),
    method: 'GET',
    queryParams: {
      date: selectedDate,
      siteId: selectedSiteId,
    },
    opts: {
      enabled: !!selectedSiteId,
      refetchOnWindowFocus: false,
      refetchInterval: MIN_15,
    },
  });

  const chartData = response?.data ? {
    labels: response.data.map((item) => item.time),
    datasets: [
      {
        ...emptyChartData.datasets[0],
        data: response.data.map((item) => item.mfrrUpEnergyPrice.value),
      },
      {
        ...emptyChartData.datasets[1],
        data: response.data.map((item) => item.mfrrDownEnergyPrice.value),
      },
      {
        ...emptyChartData.datasets[2],
        data: response.data.map((item) => item.afrrUpEnergyPrice.value),
      },
      {
        ...emptyChartData.datasets[3],
        data: response.data.map((item) => item.afrrDownEnergyPrice.value),
      },
    ],
  } : emptyChartData;

  return {
    ...response,
    chartData,
  };
};

export default useFetchFfrEnergyPrice;